import { Card, CardContent } from '@/components/ui/card'
import { Skeleton } from '@/components/ui/skeleton'
import { type AgentRunParams, useAgentRunOverview } from '@/models/agentRunReport'
import { MetricTrendChart } from './MetricTrendChart'
import { RunsByAgentChart } from './RunsByAgentChart'
import { StatTiles } from './StatTiles'

export function OverviewTab({ params }: { params: AgentRunParams }) {
  const { data, isLoading } = useAgentRunOverview(params)

  if (isLoading || !data) {
    return (
      <div className="flex flex-col gap-6">
        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 xl:grid-cols-7">
          {Array.from({ length: 7 }).map((_, index) => (
            <Skeleton key={index} className="h-24 w-full" />
          ))}
        </div>
        <Skeleton className="h-96 w-full" />
        <Skeleton className="h-72 w-full" />
      </div>
    )
  }

  return (
    <div className="flex flex-col gap-6">
      <StatTiles totals={data.totals} />
      <Card>
        <CardContent className="flex flex-col gap-4 p-4">
          <h3 className="text-md font-semibold">Runs by agent</h3>
          <RunsByAgentChart buckets={data.buckets} series={data.series} granularity={data.granularity} />
        </CardContent>
      </Card>
      <Card>
        <CardContent className="p-4">
          <MetricTrendChart buckets={data.buckets} granularity={data.granularity} />
        </CardContent>
      </Card>
    </div>
  )
}
